import React, { useState } from "react";
import { _getTranslation } from "../utils/helper";

const MobileFilters = (props) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      className={`rmf-container ${isActive ? "active" : ""} ${
        props.class ?? ""
      }`}
    >
      <button
        className={`rmf-toggle ${isActive ? "active" : ""}`}
        onClick={() => setIsActive(!isActive)}
      >
        {_getTranslation("filter")}
      </button>

      {isActive && <div className="rmf-body">{props.children}</div>}
    </div>
  );
};

export default MobileFilters;
